import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer"; // Footer Import kiya
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Tracker from "./pages/Tracker";
import BabyCare from "./pages/BabyCare";
import StiAssessment from "./pages/StiAssessment";
import AboutUs from "./pages/AboutUs";
import FloraCarePlus from "./pages/FloraCarePlus";

import "./style.css";

// Protected Route Logic
const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loader">Checking session...</div>;
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        {/* Sabse pehle scroll reset logic */}
        <ScrollToTop />

        <Navbar />

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/floracare-plus" element={<FloraCarePlus />} />

          {/* Private/Protected Routes */}
          <Route
            path="/tracker"
            element={
              <Protected>
                <Tracker />
              </Protected>
            }
          />

          <Route
            path="/babycare"
            element={
              <Protected>
                <BabyCare />
              </Protected>
            }
          />

          <Route
            path="/sti-assessment"
            element={
              <Protected>
                <StiAssessment />
              </Protected>
            }
          />

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>

        {/* 🏁 Footer ko Routes ke bahar rakha hai taaki ye har page par niche dikhe */}
        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;
